<template>
  <section class="p-p-1" :style="{ background: isSuccess ? '' : '#ebf6ff' }">
    <div class="p-m-2 title" v-if="allowOnlyHok">
      {{ __("Creating a standing order") }}
    </div>

    <div class="">
      <div class="p-d-flex p-ai-center" v-if="!allowOnlyHok">
        <p-vue-radio
          class="radio p-m-2"
          id="save-hok"
          :value="true"
          v-model="saveHok"
        />
        <label for="save-hok">{{
          __("Save my card details for automatic monthly payment,")
        }}</label>
      </div>
      <div class="p-m-2" v-if="saveHok">
        <span class="p-mx-2">
          {{ __("billing day") }}
        </span>
        <i-override-dropdown
          :options="days"
          optionLabel="DayInMonth"
          optionValue="DayInMonth"
          v-model="chargeDay"
        ></i-override-dropdown>
      </div>

      <label for="hok-date-limited" class="p-d-flex p-ai-center" v-if="saveHok">
        <p-vue-radio
          id="hok-date-limited"
          name="hokDate"
          value="1"
          v-model="hokDate"
          class="radio p-mx-2"
        />
        <span class="p-mx-2">
          {{ __("Unlimited") }}
        </span>
      </label>
    </div>

    <label v-if="saveHok" class="p-my-2 p-d-flex p-ai-center">
      <p-vue-radio class="radio p-mx-2" v-model="hokDate" value="2" />

      <span class="p-mx-2">
        {{ __("Limit to date") }}
      </span>
      <p-vue-calendar
        v-show="hokDate == 2"
        v-model="limitToDate"
        :minDate="minDate"
        :manualInput="false"
      />
    </label>
    <div class="points">
      <i class="pi pi-check"></i
      ><label>{{ __("Does not occupy a frame") }} </label>
      <br />
      <i class="pi pi-check"></i><label>{{ __("Secure and easy") }}</label>
    </div>

    <label v-if="!allowOnlyHok" for="unsave" class="p-d-flex p-ai-center">
      <p-vue-radio
        class="radio p-m-2"
        id="unsave"
        :value="false"
        v-model="saveHok"
      />
      <span>{{ __("Dont Save Card Credentials") }}</span>
    </label>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { errorReceived } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
export default {
  name: "HokRadio",
  emits: ["saveHokChange", "hokDateChange", "updateData"],
  props: {
    isSuccess: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    saveHok: null,
    hokDate: "1",
    limitToDate: new Date(),
    minDate: new Date(),
    allowOnlyHok: false,
    chargeDay: null,
    days: [],
  }),
  mounted() {
    if (this.HokFiledChangeCard) {
      this.saveHok = true;
      this.$store.commit("setHokFiledChangeCard", false);
    }
    this.getData();
    // this.AllowOnlyHok();
  },

  methods: {
    getData() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("ContactID", this.contactId, apiPType.Int)];
      callProc("App_CreateHokData", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);

          this.allowOnlyHok = Boolean(+result.Table1[0].tenantAppAllowOnlyHok);
          // this.allowOnlyHok = false;

          if (this.allowOnlyHok) this.saveHok = Boolean(this.allowOnlyHok);

          this.days = result.Table;

          let date = new Date().getDate();
          let datesFiltered = this.days.filter((f) => f.DayInMonth <= date);
          if (datesFiltered.length > 0)
            this.chargeDay = datesFiltered[datesFiltered.length - 1].DayInMonth;
          else this.chargeDay = this.days[this.days.length - 1].DayInMonth;
          this.limitToDate = this.minDate = new Date(
            result.Table2[0].minValidTo
          );

          this.$store.dispatch("doLoading", false);
        })
        .catch((error) => {
          errorReceived(error);
        });
    },
  },
  computed: {
    ...mapState({
      HokFiledChangeCard: (state) => state.HokFiledChangeCard,
      contactId: (state) => state.api.contactID,
    }),
  },
  watch: {
    saveHok: {
      // immediate: true,
      handler() {
        if (this.isSuccess) return;
        this.$emit("saveHokChange", this.saveHok);
        if (this.saveHok) {
          const oneMonthFromNow = new Date().getMonth() + 1;
          this.limitToDate.setMonth(oneMonthFromNow);
          this.minDate.setMonth(oneMonthFromNow);
        }
      },
    },
    limitToDate() {
      this.$emit("updateData", "limitToDate", this.limitToDate);
      this.$emit("updateData", "minDate", this.minDate);
    },
    minDate() {
      this.$emit("updateData", "minDate", this.minDate);
    },
    chargeDay() {
      this.$emit("updateData", "chargeDay", this.chargeDay);
    },
    hokDate: {
      immediate: true,
      handler() {
        const { hokDate, limitToDate } = this;
        this.$emit("hokDateChange", { hokDate, limitToDate });
      },
    },
  },
};
</script>

<style scoped>
.points {
  padding: 0 25px;
}

.points > i {
  margin-bottom: 10px;
  margin-left: 5px;
}

.points:deep(.pi-check) {
  color: var(--color-success);
}

.radio:deep(.p-radiobutton-box) {
  border: 1px solid #277dbe;
}

.title {
  color: var(--color-accent);
  font-weight: 700;
}
</style>
